let debug = require('debug')('APP:UTIL')

// sky_947dbf84423049a79b575672fb4e4f84_win

export function getRandomUsername():string {
    let randId = getRandomNumber()
    return 'sky_' + randId + '_ios'
}

export function getRandomDeviceId():string {
    return getRandomNumber()
}

function getRandomNumber():string {
    let uuid:string = require('uuid/v1')()
    uuid = uuid.replace(/-/g, '')
    return uuid
}

export function isSafariIos():boolean {
    let ua = window.navigator.userAgent;
    debug("ua:::", ua);
    let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i) || !!ua.match(/Mac OS X/i);
    debug("iOS:::", iOS);
    let webkit = !!ua.match(/WebKit/i);
    debug("webkit:::", webkit);
    let iOSSafari = iOS && webkit && !ua.match(/CriOS/i) && !ua.match(/MicroMessenger/i) && !ua.match(/UCBrowser/);
    debug("iOSSafari:::", iOSSafari);
    return iOSSafari
}

export function isHomeScreenApp():boolean {
    return (window.navigator as any).standalone
}
